import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import sbStyles from './sidebar.module.scss';

export default function Sidebar({ isMobile }) {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [activeItem, setActiveItem] = useState('');

    // العناصر التي ستظهر في الشريط الجانبي (بدون التكرار مع Navbar)
    const sidebarItems = [
        { key: 'services', path: '/services' },
        { key: 'training', path: '/training' },
        { key: 'gallery', path: '/gallery' },
        { key: 'team', path: '/team' },
    ];

    // العناصر التي ستخفي في الوضع المتنقل (لأنها موجودة في Navbar)
    const navbarItems = ['home', 'about', 'projects', 'documents'];
    const navbarItems2 = ['contact'];

    useEffect(() => {
        // تحديد العنصر النشط بناء على المسار الحالي
        const currentPath = location.pathname;
        const active = sidebarItems.find(item => item.path === currentPath);
        if (active) {
            setActiveItem(active.key);
        }
    }, [location.pathname, sidebarItems]);

    return (
        <div className={`${sbStyles.sidebar} ${isMobile ? sbStyles.sidebar_mobile : ''}`}>
            <ul className={sbStyles.sidebarList}>
                {/* إظهار عناصر Navbar في الشاشات الكبيرة فقط */}
                {!isMobile && navbarItems.map((item) => (
                    <li
                        key={item}
                        className={`${sbStyles.row} ${location.pathname === `/${item}` ? sbStyles.active : ''}`}
                    >
                        <Link
                            to={`/${item}`}
                            className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : ''}`}
                        >
                            {t(item)}
                        </Link>
                    </li>
                ))}

                {sidebarItems.map((item) => (
                    <li
                        key={item.key}
                        className={`${sbStyles.row} ${activeItem === item.key ? sbStyles.active : ''}`}
                    >
                        <Link
                            to={item.path}
                            className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : ''}`}
                        >
                            {t(item.key)}
                        </Link>
                    </li>
                ))}

                {/* إظهار عناصر Navbar في الشاشات الكبيرة فقط */}
                {!isMobile && navbarItems2.map((item) => (
                    <li
                        key={item}
                        className={`${sbStyles.row} ${location.pathname === `/${item}` ? sbStyles.active : ''}`}
                    >
                        <Link
                            to={`/${item}`}
                            className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : ''}`}
                        >
                            {t(item)}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}